/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { CoreApiClientService } from 'pn-core-code';

import { apiBaseUrl } from '../api-base-url';
import { CostAppraisalPaginationResponseDto } from '../model/costAppraisalPaginationResponseDto';
import { CostAppraisalRequestDto } from '../model/costAppraisalRequestDto';
import { CostAppraisalResponseDto } from '../model/costAppraisalResponseDto';
import { ValidationError } from '../model/validationError';

export enum costAppraisalsGetStatusEnum {
  draft = 'draft',
  active = 'active',
  in_active = 'in_active',
}
export enum costAppraisalsIdGetLanguageEnum {
  th = 'th',
  en = 'en',
}

@Injectable({
  providedIn: 'root',
})
export class CostAppraisalsService {

  constructor(
    protected api: CoreApiClientService) {
  }

  /**
   * [Authorize] type: http
   */
  public costAppraisalsActiveIdPost$(id: string): Observable<string> {
    return this.api.post(`${apiBaseUrl()}/cost-appraisals/active/${encodeURIComponent(String(id))}`, undefined, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public costAppraisalsGet$(page?: number, limit?: number, status?: string, beginEffectiveDate?: string, endEffectiveDate?: string, sort?: string): Observable<CostAppraisalPaginationResponseDto> {
    return this.api.get(`${apiBaseUrl()}/cost-appraisals`, { page, limit, status, beginEffectiveDate, endEffectiveDate, sort });
  }
  /**
   * [Authorize] type: http
   */
  public costAppraisalsIdDelete$(id: string): Observable<string> {
    return this.api.delete(`${apiBaseUrl()}/cost-appraisals/${encodeURIComponent(String(id))}`, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public costAppraisalsIdGet$(id: string, language?: string): Observable<CostAppraisalResponseDto> {
    return this.api.get(`${apiBaseUrl()}/cost-appraisals/${encodeURIComponent(String(id))}`, { language });
  }
  /**
   * [Authorize] type: http
   */
  public costAppraisalsIdPut$(id: string, body: CostAppraisalRequestDto): Observable<CostAppraisalResponseDto> {
    return this.api.put(`${apiBaseUrl()}/cost-appraisals/${encodeURIComponent(String(id))}`, body, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public costAppraisalsPost$(body: CostAppraisalRequestDto): Observable<CostAppraisalResponseDto> {
    return this.api.post(`${apiBaseUrl()}/cost-appraisals`, body, undefined);
  }
}
